
























































import Vue from "vue";

export default Vue.extend({
  name: "App",

  metaInfo: {
    title: "Home",
    titleTemplate: "%s | Educabinh"
  },

  components: {},

  data() {
    return {};
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  methods: {
    goToHome() {
      this.$router.push("/");
    },
    goToLessonb() {
      this.$router.push("/product/lessonb");
    },
    goToScoredent() {
      this.$router.push("/product/scoredent");
    },
    goToAbout() {
      this.$router.push("/about");
    },
    goToPrivacyPolicy() {
      this.$router.push("/privacypolicy");
    },
  },
});
